import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { toast } from 'react-toastify'
import SubscriptionsStore from './../../../../Subscriptions.store'
import { UIInput } from './../../../../../../components/forms/form-fields'
import PromoteCodeService from '../../../../../../shared/services/PromotionCode.service'
import { MDBBtn } from 'mdbreact'

const determineElligibleForPromo = () => {
  const u_enrolled = new Date(SubscriptionsStore.User?.get('u_enrolled')) // Your u_enrolled date
  const currentDate = new Date()

  // Check if within the last 30 days
  const msInDay = 24 * 60 * 60 * 1000
  const isWithinLast30Days = (currentDate - u_enrolled) / msInDay <= 30

  // Check if within the same month
  const isSameMonth =
    u_enrolled.getFullYear() === currentDate.getFullYear() &&
    u_enrolled.getMonth() === currentDate.getMonth()

  // Final result (if either condition is true)
  return !(isWithinLast30Days || isSameMonth)
}

const validatePromoCode = async (code) => {
  const result = await PromoteCodeService.search({ search: { code } })

  if (result?.models?.length > 0) {
    const currentTime = new Date(),
      // Get the timezone offset in minutes
      timezoneOffset = currentTime.getTimezoneOffset()

    // Parse the start and end time from the provided string
    const startTime = new Date(result.models[0]?.start_at),
      endTime = new Date(result.models[0]?.end_at)
    endTime.setDate(endTime.getDate() + 1)

    const convertedStartTime = new Date(
        startTime.getTime() + timezoneOffset * 60000
      ),
      convertedEndTime = new Date(endTime.getTime() + timezoneOffset * 60000)

    return convertedEndTime > currentTime && convertedStartTime <= currentTime
  }

  return false
}

const onSubmitPromoteCode = async (event, code) => {
  event.preventDefault()

  if (await validatePromoCode(code)) {
    SubscriptionsStore.isAdminFeeWaived = true
    toast.success('Promotion Code is valid.', {
      position: toast.POSITION.TOP_RIGHT,
    })
  } else {
    toast.error('Promotion Code is not valid.', {
      position: toast.POSITION.TOP_RIGHT,
    })
  }
}

const PromoCodeSubmitter = () => {
  const [code, setCode] = useState(''),
    [isValidating, setIsValidating] = useState('')

  if (!SubscriptionsStore.User?.id()) return <></>

  if (!determineElligibleForPromo()) return <></>

  let customerExists = !!SubscriptionsStore.customer?.id

  return (
    <form
      noValidate
      onSubmit={async (evt) => {
        setIsValidating(true)
        await onSubmitPromoteCode(evt, code)
        setIsValidating(false)
      }}
      className="mt-4"
    >
      <div className="d-flex align-items-center justify-content-between">
        <UIInput
          label="Promotion Code"
          name="promote_code"
          className="promote-code"
          value={code || ''}
          onChange={(evt) => setCode(evt.target.value)}
          required={true}
          rules={{ required: true }}
          type="text"
        />

        <MDBBtn
          disabled={!code || isValidating || !customerExists}
          color="primary"
          type="submit"
        >
          {isValidating ? (
            <i className="fa fa-spin fa-spinner" />
          ) : (
            <>Check Code</>
          )}
        </MDBBtn>
      </div>
    </form>
  )
}

export default observer(PromoCodeSubmitter)
